import { API_CALL } from '../../../../middleware/api';
import {
  ADD_SUPERUSER_HEALTH_ISSUE,
  ADD_SUPERUSER_HEALTH_ISSUE_COMMENT,
  EDIT_SUPERUSER_HEALTH_ISSUE,
  GET_SUPERUSER_ADMIN_ROLES,
  GET_SUPERUSER_ADMIN_USERS,
  GET_SUPERUSER_HEALTH_EVENT_DETAILS,
  GET_SUPERUSER_HEALTH_EVENT_DETAILS_FORM_BUNDLE,
  GET_SUPERUSER_HEALTH_EVENTS_OVERVIEW,
  GET_SUPERUSER_HEALTH_FAIL_CODE_ANALYSIS,
  GET_SUPERUSER_HEALTH_FAILED_EVENTS,
  GET_SUPERUSER_HEALTH_FAILED_EVENTS_FORM_BUNDLE,
  GET_SUPERUSER_HEALTH_ISSUE,
  GET_SUPERUSER_HEALTH_ISSUES,
  GET_SUPERUSER_HEALTH_MESSAGE_DETAILS,
  GET_SUPERUSER_HEALTH_MESSAGE_DETAILS_FORM_BUNDLE,
  POST_SUPERUSER_HEALTH_MESSAGE_RECHECK_PENDING,
  GET_SUPERUSER_HEALTH_MESSAGES_OVERVIEW,
  UPDATE_SUPERUSER_HEALTH_FAILED_EVENT,
  GET_SUPERUSER_HEALTH_ALERT_RULES,
  CREATE_SUPERUSER_HEALTH_ALERT_RULE,
  UPDATE_SUPERUSER_HEALTH_ALERT_RULE,
  DELETE_SUPERUSER_HEALTH_ALERT_RULE,
  GET_SUPERUSER_HEALTH_ALERT_RULE_SUBSCRIPTIONS,
  CREATE_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION,
  UPDATE_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION,
  DELETE_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION,
  SEARCH_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION_USERS,
  GET_SUPERUSER_HEALTH_ALERT_INCIDENTS,
  TEST_SUPERUSER_HEALTH_ALERT_RULE,
} from './constants';

export default {
  getMessagesOverview: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/messages/overview',
      params,
    },
    type: GET_SUPERUSER_HEALTH_MESSAGES_OVERVIEW,
  }),
  getIssues: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/issues/',
      params,
    },
    type: GET_SUPERUSER_HEALTH_ISSUES,
  }),
  getIssue: id => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/issues/${id}`,
    },
    type: GET_SUPERUSER_HEALTH_ISSUE,
  }),
  addIssue: data => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/issues/',
      data,
    },
    type: ADD_SUPERUSER_HEALTH_ISSUE,
  }),
  editIssue: (id, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/issues/${id}`,
      data,
    },
    type: EDIT_SUPERUSER_HEALTH_ISSUE,
  }),
  addIssueComment: (id, data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/issues/${id}/comment`,
      data,
    },
    type: ADD_SUPERUSER_HEALTH_ISSUE_COMMENT,
  }),
  getAdminRoles: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/roles',
      params,
    },
    type: GET_SUPERUSER_ADMIN_ROLES,
  }),
  getAdminUsers: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/users',
      params,
    },
    type: GET_SUPERUSER_ADMIN_USERS,
  }),
  getMessageDetails: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/messages/details',
      params,
    },
    type: GET_SUPERUSER_HEALTH_MESSAGE_DETAILS,
  }),
  getMessageDetailsFormBundle: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/messages/details/form-bundle',
    },
    type: GET_SUPERUSER_HEALTH_MESSAGE_DETAILS_FORM_BUNDLE,
  }),
  recheckPendingMessage: id => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/superadmin/health-monitor/messages/details/${id}/recheck-status`,
      data: {},
    },
    type: POST_SUPERUSER_HEALTH_MESSAGE_RECHECK_PENDING,
  }),
  getEventsOverview: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/events/overview',
      params,
    },
    type: GET_SUPERUSER_HEALTH_EVENTS_OVERVIEW,
  }),
  getFailCodeAnalysis: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/events/fail-code-analysis',
      params,
    },
    type: GET_SUPERUSER_HEALTH_FAIL_CODE_ANALYSIS,
  }),
  getEventDetails: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/events/details',
      params,
    },
    type: GET_SUPERUSER_HEALTH_EVENT_DETAILS,
  }),
  getEventDetailsFormBundle: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/events/details/form-bundle',
    },
    type: GET_SUPERUSER_HEALTH_EVENT_DETAILS_FORM_BUNDLE,
  }),
  getFailedEvents: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/events/failed',
      params,
    },
    type: GET_SUPERUSER_HEALTH_FAILED_EVENTS,
  }),
  getFailedEventsFormBundle: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/events/failed/form-bundle',
    },
    type: GET_SUPERUSER_HEALTH_FAILED_EVENTS_FORM_BUNDLE,
  }),
  updateFailedEvent: (id, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/health-monitor/events/failed/${id}`,
      data,
    },
    type: UPDATE_SUPERUSER_HEALTH_FAILED_EVENT,
  }),
  // Alert Rules
  getAlertRules: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/alerts/rules',
      params,
    },
    type: GET_SUPERUSER_HEALTH_ALERT_RULES,
  }),
  createAlertRule: data => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: 'portal/v1/superadmin/health-monitor/alerts/rules',
      data,
    },
    type: CREATE_SUPERUSER_HEALTH_ALERT_RULE,
  }),
  updateAlertRule: (ruleId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/health-monitor/alerts/rules/${ruleId}`,
      data,
    },
    type: UPDATE_SUPERUSER_HEALTH_ALERT_RULE,
  }),
  deleteAlertRule: ruleId => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: `portal/v1/superadmin/health-monitor/alerts/rules/${ruleId}`,
    },
    type: DELETE_SUPERUSER_HEALTH_ALERT_RULE,
  }),
  // Alert Subscriptions
  getRuleSubscriptions: ruleId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/health-monitor/alerts/rules/${ruleId}/subscriptions`,
    },
    type: GET_SUPERUSER_HEALTH_ALERT_RULE_SUBSCRIPTIONS,
  }),
  createSubscription: (ruleId, data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/superadmin/health-monitor/alerts/rules/${ruleId}/subscriptions`,
      data,
    },
    type: CREATE_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION,
  }),
  updateSubscription: (subscriptionId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/health-monitor/alerts/subscriptions/${subscriptionId}`,
      data,
    },
    type: UPDATE_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION,
  }),
  deleteSubscription: subscriptionId => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: `portal/v1/superadmin/health-monitor/alerts/subscriptions/${subscriptionId}`,
    },
    type: DELETE_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION,
  }),
  searchSubscriptionUsers: search => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/admin/users',
      params: {
        search,
        limit: 20,
        sortColumn: 'first_name',
        sortType: 'ascending',
      },
    },
    type: SEARCH_SUPERUSER_HEALTH_ALERT_SUBSCRIPTION_USERS,
  }),
  // Alert Incidents
  getAlertIncidents: params => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/superadmin/health-monitor/alerts/incidents',
      params,
    },
    type: GET_SUPERUSER_HEALTH_ALERT_INCIDENTS,
  }),
  // Test Alert Rule
  testAlertRule: ruleId => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v1/superadmin/health-monitor/alerts/test/${ruleId}`,
    },
    type: TEST_SUPERUSER_HEALTH_ALERT_RULE,
  }),
};
